import { render, staticRenderFns } from "./GlobalRfi.vue?vue&type=template&id=1310c4d8&"
import script from "./GlobalRfi.vue?vue&type=script&lang=js&"
export * from "./GlobalRfi.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRfi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports